import { Component, Inject, ViewChild, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CommonService } from "@services/common.service";

import { MatSort, MatSortable } from "@angular/material/sort";

import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { faInfoCircle } from "@fortawesome/pro-light-svg-icons";
@Component({
    selector: "app-import",
    templateUrl: "./import.component.html",
    styleUrls: ["./import.component.scss"],
    standalone: false
})
export class ImportDialogComponent implements OnInit {
  message: string = "Are you sure?";
  actionButton: string = "delete";
  messageDetail: string = "";
  details: any = [];
  canvasData: any = [];
  displayedColumns: string[] = ["canvasName", "categoryName", "buildName"];
  dataSource: any;
  status: boolean = false;
  faInfoCircle = faInfoCircle;
  constructor(
    public commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ImportDialogComponent>
  ) {
    if (data) {
      this.message = data.message || this.message;
      this.messageDetail = data.messageDetail || this.messageDetail;
      this.details = data.details || this.details;
      this.actionButton = data.actionButton || this.actionButton;
      this.canvasData = data.canvasData;
      // this.canvasData = [];
      this.status = data.status;
      if (this.status) {
        this.displayedColumns = ["canvasName", "status", "error"];
      }
      if (data.actionButton) {
        this.actionButton = data.actionButton;
      }
    }
  }

  @ViewChild(MatPaginator) paginator: MatPaginator | undefined;
  @ViewChild(MatSort) sort!: MatSort;
  onNoClick(): void {
    this.dialogRef.close();
  }
  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
  ngOnInit() {
    this.dataSource = new MatTableDataSource(<any>this.canvasData);
    setTimeout(() => (this.dataSource.paginator = this.paginator));
    setTimeout(() => {
      this.dataSource.sort = this.sort;
    }, 10);
  }
}
